module.exports = __webpack_public_path__ + "img/charecter-upgrade1.4be5049c.png";